import {
    ACTUALIZAR_LIST_PELIGRO,
    AGREGAR_PELIGRO,
  } from "./peligroActions";

  const peligroReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_PELIGRO: {
            return {
                ...state,
                peligroIDLista: action.payload
            }
        };

        case AGREGAR_PELIGRO:{
            return {
                 ...state,
                 peligroIDLista: [action.payload, ...state.peligroIDLista]
             }
         };

        default:
            return state;

    }
  }

  export default peligroReducer;
